import { render, staticRenderFns } from "./TestLiteralEditor.vue?vue&type=template&id=4e8db37b&"
import script from "./TestLiteralEditor.vue?vue&type=script&lang=js&"
export * from "./TestLiteralEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports